// keyrd_console/src/components/PilotStatusPill.js
import React from "react";

const STATUS_MAP = {
  drafted: { label: "Drafted", bg: "#f3f4f6", color: "#374151", border: "#d1d5db" },
  consented: { label: "Consented", bg: "#dbeafe", color: "#1d4ed8", border: "#93c5fd" },
  "baseline-ready": { label: "Baseline-ready", bg: "#ede9fe", color: "#6d28d9", border: "#c4b5fd" },
  "device-ready": { label: "Device-ready", bg: "#cffafe", color: "#155e75", border: "#67e8f9" },
  "shadow-active": { label: "Shadow-Active", bg: "#ecfccb", color: "#3f6212", border: "#bef264" },
  approved_for_next_stage_review: { label: "Approved for Next Stage Review", bg: "#dcfce7", color: "#166534", border: "#86efac" },
  hold: { label: "Hold", bg: "#fef3c7", color: "#92400e", border: "#fcd34d" },
  rejected_needs_correction: { label: "Rejected / Needs Correction", bg: "#fee2e2", color: "#b91c1c", border: "#fca5a5" },
  paused: { label: "Paused", bg: "#fee2e2", color: "#991b1b", border: "#fca5a5" },
  review_pending: { label: "Review Pending", bg: "#e0e7ff", color: "#3730a3", border: "#a5b4fc" },
  suppressed: { label: "Suppressed", bg: "#ffedd5", color: "#9a3412", border: "#fdba74" },
  cooldown_active: { label: "Cooldown Active", bg: "#fef3c7", color: "#92400e", border: "#fcd34d" },
  active: { label: "Active", bg: "#dcfce7", color: "#166534", border: "#86efac" },
  complete: { label: "Complete", bg: "#dcfce7", color: "#166534", border: "#86efac" },
  incomplete: { label: "Incomplete", bg: "#f3f4f6", color: "#374151", border: "#d1d5db" },
  yes: { label: "Yes", bg: "#dcfce7", color: "#166534", border: "#86efac" },
  no: { label: "No", bg: "#f3f4f6", color: "#374151", border: "#d1d5db" },
  true: { label: "True", bg: "#dcfce7", color: "#166534", border: "#86efac" },
  false: { label: "False", bg: "#f3f4f6", color: "#374151", border: "#d1d5db" },
  unknown: { label: "Unknown", bg: "#f9fafb", color: "#4b5563", border: "#d1d5db" },
};

function normalizeStatus(status) {
  if (status === null || status === undefined || status === "") return "unknown";
  return String(status).trim().toLowerCase().replace(/\s+/g, "_");
}

const pillStyle = (entry) => ({
  display: "inline-flex",
  alignItems: "center",
  padding: "4px 8px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 600,
  background: entry.bg,
  color: entry.color,
  border: `1px solid ${entry.border}`,
  whiteSpace: "nowrap",
});

function PilotStatusPill({ status, label }) {
  const normalized = normalizeStatus(status);
  const entry = STATUS_MAP[normalized] || STATUS_MAP.unknown;

  return (
    <span style={pillStyle(entry)}>
      {label || entry.label}
    </span>
  );
}

export default PilotStatusPill;